<div class="content-container" role="main" [attr.aria-busy]="!ticket ? 'true' : 'false'" aria-live="assertive">
  @if (theme.theme.mainTheme !== themeType.Custom) {
    <id-card>
      <ng-container *ngTemplateOutlet="bankIdAuthenticationContent"></ng-container>
    </id-card>
  } @else {
    <div class="custom-card">
      <ng-container *ngTemplateOutlet="bankIdAuthenticationContent"></ng-container>
    </div>
  }

  <ng-template #bankIdAuthenticationContent>
    <div class="flex flex-column flex-align-center">
      <img class="icon" src="assets/images/logo-bank-id.svg" alt="SITHS eID ikon" />

      <h1 class="{{ theme.theme.mainTheme !== themeType.Custom ? 'ids-heading-xl' : 'custom-heading-xl' }} ids-mt-5">
        {{ getTypeText() }}
      </h1>
      <h2 class="{{ theme.theme.mainTheme !== themeType.Custom ? 'ids-heading-l' : 'custom-heading-l' }}">
        {{ clientInfo?.organizationName }}
      </h2>

      @if (!pending) {
        @if (ticket) {
          <div class="panel-content flex flex-align-center flex-column">
            @if (isSameDevice) {
              <div class="instructions-text-container">
                @if (!isAndroid || (isAndroid && !isSingleMethod())) {
                  <p class="instructions-text">Applikationen BankID startas på din enhet.</p>
                }

                @if (isAndroid && isSingleMethod()) {
                  <p class="instructions-text">
                    <strong> Tryck på knappen nedan för att starta BankID på denna enhet. </strong>
                  </p>
                }

                <p class="instructions-text">
                  Följ instruktionerna i appen för att slutföra {{ getMethodTypeText() }}.
                </p>
              </div>
            }

            @if (!isSameDevice) {
              @if (displayQrCode) {
                <div class="flex">
                  <div class="column flex-column">
                    <div class="qr-container flex">
                      <div class="flex">
                        <div class="flex flex-center">
                          <img [src]="base64Prefix + qrTokenB64" alt="QR-kod" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }

              <div class="ids-mb-5">
                <ol>
                  <li>Öppna appen för BankID.</li>
                  <li>Tryck på QR-symbolen i appen för BankID.</li>
                  <li>Rikta kameran mot QR-koden ovan.</li>
                  <li>Följ instruktionerna i appen för att logga in.</li>
                </ol>
              </div>
              <div class="ids-divider full-width"></div>

              @if (!isStarting) {
                <div class="ids-mt-5 flex flex-column align-center">
                  <p>Har du BankID på den här enheten?</p>

                  <id-link>
                    <a href="javascript:void(0);" (click)="manualAutostart()"
                      >Om du har BankID på den här enheten kan du klicka här för att logga in.</a
                    >
                  </id-link>
                </div>
              }

              @for (link of theme.content.links; track $index) {
                <div class="ids-mt-5 flex flex-column align-center">
                  <p>{{ link.title }}</p>
                  <id-link>
                    <a [href]="link.url">{{ link.urlText }}</a>
                  </id-link>
                </div>
              }
            }

            @if (isStarting) {
              <app-loading-spinner></app-loading-spinner>
            }

            <div class="ids-mt-5">
              <id-link>
                <a href="javascript:void(0);" (click)="cancelAuthentication()">Avbryt {{ getMethodTypeText() }}</a>
              </id-link>
            </div>
          </div>
        } @else {
          <app-loading-spinner></app-loading-spinner>
        }
      }

      @if (pending) {
        <div class="panel-heading" id="idp-siths-eid-method-header">
          <img src="assets/images/bank-id-logo.svg" alt="BankID ikon" />
          <p role="heading">Slutför {{ getMethodTypeText() }}</p>
        </div>

        <div class="panel-content flex flex-align-center flex-column">
          <div class="instructions-text-container">
            <p class="instructions-text">
              Följ anvisningar i BankID applikationen för att slutföra {{ getMethodTypeText() }}.
            </p>
          </div>

          <div class="flex flex-center margin-50">
            <app-loading-spinner></app-loading-spinner>
          </div>

          <div class="ids-mt-5">
            <id-link>
              <a href="javascript:void(0);" (click)="cancelAuthentication()">Avbryt {{ getMethodTypeText() }}</a>
            </id-link>
          </div>
        </div>
      }
    </div>
  </ng-template>
</div>
